import React from 'react';
import { SectionTitle } from '../ui/SectionTitle';

export function Historia() {
    return (
        <section className="bg-white py-16 px-4" id="historia">
            <div className="max-w-4xl mx-auto text-center">
                <SectionTitle subtitle="Nacido de una experiencia real">
                    La historia detrás de SmartPet
                </SectionTitle>
                <div className="bg-sp-light rounded-3xl p-8 text-left shadow-sp">
                    <p className="text-lg font-semibold text-sp-text leading-relaxed">
                        “Cuando encontraron a Minerva, tenía su chapita con mi número.
                        Pero lo leyeron mal. Falló lo más básico.
                        Ahí entendí que un número grabado no es suficiente.”
                    </p>
                    <p className="mt-4 text-sp-body leading-relaxed">
                        Por eso creé SmartPet. No es GPS, es mucho más simple y eterno:
                        un carnet digital en su collar. Sin baterías, sin suscripción,
                        y con una base de datos que te avisa al instante dónde está tu mascota.
                    </p>
                    <p className="mt-4 text-sp-body leading-relaxed">
                        Hoy, miles de mascotas ya están protegidas. Y la tuya también puede estarlo.
                    </p>
                    <div className="mt-6 flex justify-center">
                        <span className="inline-block bg-sp-primary text-white px-6 py-2 rounded-full text-sm font-bold">
                            Juanma Toniolo — Fundador
                        </span>
                    </div>
                </div>
            </div>
        </section>
    );
}